import H from 'constants/httpMethod.const';
import fromDtoToSalonVat from 'dto/salon/fromDtoToSalonVat.dto';
import fromSalonVatToDto from 'dto/salon/fromSalonVatToDto.dto';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const abeSalonVatRead = actionEndpointBe('abeSalonVatRead', H.get, 'salon/:salonId/vat/', {
  inert: false,
  fromDto: fromDtoToSalonVat,
});

export const ibeSalonVatRead = actionEndpointBe('ibeSalonVatRead', H.get, 'salon/:salonId/vat/', {
  inert: true,
  fromDto: fromDtoToSalonVat,
});
//
export const abeSalonVatUpdate = actionEndpointBe('abeSalonVatUpdate', H.patch, 'salon/:salonId/vat/', (options, extra) => ({
  ...options,
  fromDto: fromDtoToSalonVat,
  toDto: fromSalonVatToDto,
  data: extra?.data,
}));

export const ibeSalonVatUpdate = actionEndpointBe('ibeSalonVatUpdate', H.patch, 'salon/:salonId/vat/', (options, extra) => ({
  ...options,
  inert: true,
  fromDto: fromDtoToSalonVat,
  toDto: fromSalonVatToDto,
  data: extra?.data,
}));
